import { tKeys } from '@/i18n/resourses';

import { GAMEZONE_URL } from '@/utils/constants';

export const showEntryOrEntries = (value: number | string) =>
  Number(value) === 1 ? tKeys.entry : tKeys.entries;

export const linkToGZ = (lang: string) => `${GAMEZONE_URL}?lang=${lang}`;

export const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const isTransApiValueExists = (val: string | undefined | null) =>
  !!val && val !== 'null';
